import React from 'react';
import { Toast } from 'primereact/toast';

// Global Toast referansı için servis
export const toastService = {
  toast: React.createRef(),
  messageQueue: [], // Henüz gösterilemeyen mesajları saklamak için
  
  setToastRef(ref) {
    this.toast = ref;
    // Kuyruktaki mesajları göster
    this.flushMessageQueue();
  },
  
  flushMessageQueue() {
    if (this.toast.current && this.messageQueue.length > 0) {
      this.messageQueue.forEach(msg => {
        this.toast.current.show(msg);
      });
      this.messageQueue = [];
    }
  },
  
  show(options) {
    if (this.toast.current) {
      this.toast.current.show(options);
    } else {
      console.warn('Toast referansı henüz oluşturulmadı. Mesaj kuyruğa alındı.');
      this.messageQueue.push(options);
    }
  },
  
  // Başarılı mesaj için kısa yol
  success(detail, summary = 'Success', life = 3000) {
    this.show({ severity: 'success', summary, detail, life });
  },
  
  // Hata mesajı için kısa yol
  error(detail, summary = 'Error', life = 3000) {
    this.show({ severity: 'error', summary, detail, life });
  },
  
  // Uyarı mesajı için kısa yol
  warn(detail, summary = 'Warning', life = 3000) {
    this.show({ severity: 'warn', summary, detail, life });
  },
  
  // Bilgi mesajı için kısa yol
  info(detail, summary = 'Information', life = 3000) {
    this.show({ severity: 'info', summary, detail, life });
  }
};

export default toastService;
